export const addFactura =  (data) => {
  return new Promise((resolve,reject) => {
      const myHeaders = new Headers();
  
      var formdata = new FormData();
      formdata.append("Descripcion",data.desc);
      formdata.append("pdf",data.pdf);
      formdata.append("xml",data.xml);
      
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
  
      fetch(`https://conta-api.solucioneskmp.com/Facturas/addFactura`, requestOptions)
        .then(response => response.json())
        .then(result => resolve(result))
        .catch(error => reject( error));
  })}

export const findFacturas =  (name) => {
    return new Promise((resolve,reject) => {
        const myHeaders = new Headers();
    
        var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
        };
    
        fetch(`https://conta-api.solucioneskmp.com/Facturas/getFactura/${name}`, requestOptions)
          .then(response => response.json())
          .then(result => resolve(result))
          .catch(error => reject( error));
    })}

    export const findFilePDF =  (name) => {
        return new Promise((resolve,reject) => {
            const myHeaders = new Headers();
        
            var requestOptions = {
              method: 'GET',
              headers: myHeaders,
              redirect: 'follow'
            };
        
            fetch(`https://conta-api.solucioneskmp.com/Facturas/getFilePDF/${name}`, requestOptions)
              .then(response => response.json())
              .then(result => resolve(result))
              .catch(error => reject( error));
        })}

        export const findFileXML =  (name) => {
            return new Promise((resolve,reject) => {
                const myHeaders = new Headers();
            
                var requestOptions = {
                  method: 'GET',
                  headers: myHeaders,
                //  body: formdata,
                  redirect: 'follow'
                };
            
                fetch(`https://conta-api.solucioneskmp.com/Facturas/getFileXML/${name}`, requestOptions)
                  .then(response => response.json())
                  .then(result => resolve(result))
                  .catch(error => reject( error));
            })}

    export function base64ToBlob(base64, type = "application/octet-stream") {
        const binStr = atob(base64);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
        }
        return new Blob([arr], { type: type });
    }

    export function guardarArchivo(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            const a = document.createElement('a');
            document.body.appendChild(a);
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }, 0)
        }
    }